import {
  Component,
  input,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { UserService } from 'src/app/core/common-services/user.services';
import { NotificationDto } from 'src/app/core/data-models/notification.data.models';
import { AccountDto } from 'src/app/core/data-models/user.data.models';
import { UserDataService } from 'src/app/core/data-services/identity/user.data.service';
import { NotificationDataService } from 'src/app/core/data-services/notification/notification-data.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
})
export class NavComponent implements OnInit {

  currentLang = this.languageService.currentLanguage || 'ar';
  @Input() isRtl: boolean = false;
  @Input() showSideNav!: TemplateRef<any>;
  navbarCollabsed :boolean = false
  notifications: NotificationDto[] = [];
  unreadCount = 0;
  accoutDto:AccountDto|undefined;
  constructor(
    private userService: UserService,
    private userDataService: UserDataService,
    private notificationService: NotificationDataService,
    private notificationServiceUI: NotificationService,
    public languageService: LanguageService,
    private router :Router,
    private translateService: TranslateService
  ) {}

  openNavMobile(){
    this.navbarCollabsed = !this.navbarCollabsed
  }
  logout() {
     return this.userDataService.Logout().subscribe(() => {
    this.userService.logout();
  });
  }

  ngOnInit() {
    // Initialize language properly using the language service
    this.currentLang = this.languageService.currentLanguage;
    this.isRtl = this.currentLang === 'ar';

    // Set the language in the translate service if not already set
    if (!this.languageService.currentLanguage) {
      this.languageService.setLanguage(this.currentLang);
    }

    this.loadAccountData();
    // this.loadNotifications();
    this.loadUnreadCount();
  }
  // sidemenu
  @ViewChild('sidebarRef') sidebarRef!: any;
  closeCallback(e: any): void {
    this.sidebarRef.close(e);
  }
  sidebarVisible: boolean = false;

  loadNotifications() {
    this.notificationService.GetNotificationsList(0, 50).subscribe({
      next: (res) => {
        const list = res?.data || res?.resource || [];
        this.notifications = Array.isArray(list)
          ? list.map((n) => this.mapNotification(n))
          : [];
      },
      error: (err) => {
        this.notificationServiceUI.error('Error loading notifications');
      },
    });
  }

  loadUnreadCount() {
    this.notificationService.GetUnreadNotificationsCount().subscribe({
      next: (res) => {
        this.unreadCount =
          res?.data?.unreadNotificationsCount ||
          res?.resource?.unreadNotificationsCount ||
          0;
      },
      error: (err) => {
        this.notificationServiceUI.error('Error loading unread count');
      },
    });
  }
  loadAccountData() {
  this.userDataService.GetMyAccounts().subscribe({
    next: (res) => {
      const user = res?.resource;

      if (user) {
        this.accoutDto=user;
      }
    },
    error: (err) => {
      console.error('Error loading account data', err);
    }
  });
}

  mapNotification(api: any): NotificationDto {
    return {
      id: api.notificationId || api.id || '',
      title: api.title || '',
      message: api.body || api.message || '',
      description: api.description || '',
      isRead: api.isRead || '',
      createdAt: api.createdAt || '',
    };
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const d = new Date(dateString);
    return `${d.toLocaleTimeString()} ${d.toLocaleDateString()}`;
  }

  markAsRead(id: string) {
    this.notificationService.ReadNotification(id).subscribe({
      next: () => {
        this.notifications = this.notifications.filter((n) => n.id !== id);
        if (this.unreadCount > 0) this.unreadCount--;
      },
      error: (err) => {
        this.notificationServiceUI.error('Error marking notification as read');
      },
    });
  }

  markAllAsRead() {
    this.notificationService.ReadAll().subscribe({
      next: () => {
        this.notifications = [];
        this.unreadCount = 0;
      },
      error: (err) => {
        this.notificationServiceUI.error('Error marking all notifications as read');
      },
    });
  }
      goToSetting(){
      const data  = localStorage.getItem('currentUser')
      const currentUser = data ? JSON.parse(data) :null;
      const roles = currentUser?.roles || [];
      const pureRole = roles[0].split('.')[1];
      this.router.navigate([pureRole,'account-setting'])
    }

  private toProfileImageUrl(path: string | null | undefined): string {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(path)) {
      return path;
    }
    const base = (environment as any).ossBaseUrl ?? '';
    return base ? (base.endsWith('/') ? base + path : base + '/' + path) : path;
  }

  defaultAvatar = 'assets/images/user.svg';

  get profileImageUrl(): string {
    const data = localStorage.getItem('currentUser');
    const currentUser = data ? JSON.parse(data) : null;
    const imgUrl = currentUser?.imgUrl;
    if (!imgUrl) return this.defaultAvatar;
    return this.toProfileImageUrl(imgUrl);
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.src = this.defaultAvatar;
    }
  }

}

